import { ReactComponent as CircleCheck } from 'assets/icons/CircleCheck.svg';

type AliasAvailableProps = { alias: string };

const AliasAvailable = ({ alias }: AliasAvailableProps) => {
  const pathToRooms = `${window.location.host}/rooms/`;

  return (
    <div className="flex items-center gap-1">
      <CircleCheck className="stroke-availableTextColor shrink-0" />
      <span className="text-size-sm text-availableTextColor truncate whitespace-nowrap lowercase">
        {pathToRooms}
        <span className="font-semibold">{alias}</span>
      </span>
    </div>
  );
};

export default AliasAvailable;
